import React, { useEffect, useState, Fragment, act } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import WayActivitity1 from "./WayActivity1";
import WayActivity2 from "./WayActivity2";
import WayActivity3 from "./WayActivity3";
import WayActivity4 from "./WayActivity4";
import { eventsApiDummyData, dummyAvailabilityData, dummyMybookingsApiData, eventInfoApiDummyData } from "./data";
import WayActivity5 from "./WayActivity5";
import WayActivity6 from "./WayActivity6";
import EventDetails from "./EventDetails";
import BookingConfirmation from "./BookingConfirmation";
import { popupOpenClose, setRegPage } from "../../../action/action";
import WayActivity1 from "./WayActivity1";
import { setSuccessFailPop } from "../../action/viewBillAction2";
import Loader from "../../UI/loader";
import { createTheWayActivityBooking, getAllEventsList, getAllWayBookings, getEventInfoWayActivity, getWayActivityAvailability, WAY_ACTIVITIES_USER_DATA } from "../../../action/wayActivities";
import { scrollToTop } from "../../../JS/scrollToTop";
import { closeOrderPopUp } from "../../action/hCommerce2";

// const existingBookingEmailId = localStorage.getItem(WAY_ACTIVITIES_USER_DATA) &&  JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)) && JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)).email;


const getDefaultQuestionsFormat=(count) => {
  // const existingBookingEmailId = localStorage.getItem(WAY_ACTIVITIES_USER_DATA) &&  JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)) && JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)).email;

  return {
      // purchaser: {
      //     "firstName": "",
      //     "lastName": "",
      //     "phoneNumber": "",
      //     "emailAddress": existingBookingEmailId ? existingBookingEmailId : ""
      // },
      participants: [...Array(count)].map((_,i)=>{
          return {
              "firstName": "",
              "lastName": ""
          }
      })
  }
}


const WayActivities = (props) => {
  const [currentPage, setCurrentPage] = useState(1);  // to show the stuff on the summary page 
  const [eventsData, setEventsData] = useState(null);
  const [eventDetailedInfo, setEventDetailedInfo] = useState(null);
  const [availabilityApiResponse, setAvailabilityApiResponse] = useState(null);
  const [myBookings, setMyBookings] = useState(null);
  const [selectedData, setSelectedData] = useState({
    selectedCategory: { name: "all" }
  });
  const [loaderDetails, setLoaderDetails]= useState(false);
  const [selectedParticipantCount, setSelectedParticipantCount] = useState(null);
  const [visibleTimeSlots, setVisibleTimeSlots] = useState({});
  // const [visibleTypes, setVisibleTypes] = useState(null);
  const { t } = props;

  // HANDLE FUNC - START 

  const handleSelectedDataChange = (data) => {
    data = JSON.parse(JSON.stringify(data));
    console.log("data", data)
    setSelectedData((prev) => ({
      ...prev,
      ...data
    }))
  };

  const getPriceTierName = () =>{
    let result =[];
    for( const eachPriceTier of selectedData.priceTiers ){
      for(let i=0; i < eachPriceTier.quantity ;i++){
        result.push(eachPriceTier.name);
      }
    }
    return result;
  }

  const getPriceTierPrice = ()=>{
    let result =[];
    for( const eachPriceTier of selectedData.priceTiers ){
      for(let i=0; i < eachPriceTier.quantity ;i++){
        result.push(eachPriceTier.price);
      }
    }
    return result;
  }

  const goNextPage=async (action)=>{
    console.log(action, currentPage)

    switch (currentPage){
      case 1:
        await fetchEvents(()=>{ setCurrentPage((p)=>p+1)});
        break;
      case 2:
        await fetchEventDetailedInfo(action.payload.event.id, ()=>{
          setCurrentPage((p)=>p+1);
        })
        break;
      case 3:
        await fetchAvailability(action.payload.subEvent ? action.payload.subEvent : null, ()=>{ 
          setCurrentPage((p)=>p+1)})
        break;
      case 4:
         setCurrentPage((p)=>p+1);
        break;
      case 5:
        setCurrentPage((p)=>p+1);
        break;
      case 6:
        await createBooking(()=>{ 
          setCurrentPage((p)=>p+1)}, action.payload.totalTax, action.payload.grandTotal )
        break;
      case 7:

        setEventsData(null);
        setEventDetailedInfo(null);
        setAvailabilityApiResponse(null);
        setMyBookings(null);
        setSelectedData({
          selectedCategory: { name: "all" }
        })
        setSelectedParticipantCount(null)
        setVisibleTimeSlots({})

        setCurrentPage(1);
        break;
      default:
        setCurrentPage((p)=>p+1);
      }
  }

  const goPreviousPage = async ()=>{
    let updatedSelectedData = {...selectedData};
    switch (currentPage){
      case 1:
        props.setGoHome(true);
        break;
      case 2: 
        setAvailabilityApiResponse(null);
        setSelectedData({
          selectedCategory: { name: "all" }
        })
        setCurrentPage((p)=>p-1);
        break;
      case 3:

        delete updatedSelectedData.subEvent;
       
        setEventDetailedInfo(null);
        setSelectedData(updatedSelectedData);
        setCurrentPage((p)=>p-1);
        break;
      case 4:
        delete updatedSelectedData.date;
        delete updatedSelectedData.packages;
        delete updatedSelectedData.timeSlot;
        delete updatedSelectedData.priceTiers;
        delete updatedSelectedData.type;
        if(!(selectedData.subEvent && selectedData.subEvent.length>0))  delete updatedSelectedData.subEvent;

        setVisibleTimeSlots({})
        setSelectedParticipantCount(null);
        setSelectedData(updatedSelectedData);

        if(eventDetailedInfo && eventDetailedInfo.resourceGroups && eventDetailedInfo.resourceGroups.length > 0) setCurrentPage((p)=>p-1);
        else {
          setEventDetailedInfo(null);
          setCurrentPage((p)=>p-2);
        }

        break;

      case 5:
        setCurrentPage((p)=>p-1);
        break;
      default:
        setCurrentPage((p)=>p-1);
    }

  }

// HANDLE FUNC - END 







// FETCH APIS - START

  const fetchAvailability = async (subEvent, successCb) => {
  
    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.fetching_availability")});
    try {
      await getWayActivityAvailability(selectedData.event.id, undefined, subEvent)
      .then(data=>{
        if(!data.sessions) throw { message: t("way_activity.update_booking_page.errors.missing_sessions") };
        if(data.sessions.length==0) throw { message : t("way_activity.update_booking_page.errors.no_sessions_on_date") };

        setAvailabilityApiResponse(data);
        if(successCb) successCb();
      })
      .catch((errMessage)=>{
        console.log("err", JSON.stringify(errMessage))
        props.closeOrderPopUp(true,  errMessage.message, "", true);

        const updatedSelectedData = JSON.parse(JSON.stringify(selectedData));
        delete updatedSelectedData.subEvent;
        handleSelectedDataChange({selectedData: updatedSelectedData});

        if(!(eventDetailedInfo.resourceGroups && eventDetailedInfo.resourceGroups.length >0)){
          goPreviousPage();
        }
        // remove both lines
        // setAvailabilityApiResponse(dummyAvailabilityData.payload.data);
        // if(successCb) successCb();
      })
      .finally(()=>{
        setLoaderDetails({show:false});

      })
     
    } catch (err) {
      console.error("...", err);
    }
  };

  const fetchEvents = async (successCb) => {

    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.fetching_data")});

    try {
      await getAllEventsList()
      .then(data=>{
        setEventsData(data);
        if(successCb) successCb();
      })
      .catch((errMessage)=>{
        console.log(errMessage.message)
        props.closeOrderPopUp(true, JSON.stringify(errMessage.message), "", true);

        // remove both lines
        // setEventsData(eventsApiDummyData.payload.data);
        // if(successCb) successCb();
      })
      .finally(()=>{
        setLoaderDetails({show:false });

      })
     
    } catch (err) {
      console.error("...", err);
    }
  };

  const fetchEventDetailedInfo = async (id, successCb) => {
 
    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.fetching_data")});

    try {
      await getEventInfoWayActivity(id)
      .then(data=>{
        setEventDetailedInfo(data);
        if(successCb) successCb(data);
      })
      .catch((errMessage)=>{
        props.closeOrderPopUp(true, JSON.stringify(errMessage.message), "", true);

      })
      .finally(()=>{
        setLoaderDetails({show:false });

      })
     
    } catch (err) {
      console.error("...", err);
    }
  }

  const fetchBookings = async (successCb) => {

    // const existingBookingEmailId = localStorage.getItem(WAY_ACTIVITIES_USER_DATA) &&  JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)) && JSON.parse(localStorage.getItem(WAY_ACTIVITIES_USER_DATA)).email;
    // console.log(existingBookingEmailId, "existingBookingEmailId")

    // if(!existingBookingEmailId){

    //   setMyBookings([]);
    //   return;
    // }

    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.fetching_bookings")});
    try {
      await getAllWayBookings()
      .then(data=>{
        setMyBookings(data);
        if(successCb) successCb();
      })
      .catch((errMessage)=>{
        console.log(errMessage)
        props.closeOrderPopUp(true, JSON.stringify(errMessage.message), "", true);

        // remove temp line
        // setMyBookings(eventsApiDummyData.payload.data);
      })
      .finally(()=>{
        setLoaderDetails({show:false});

      })
     
    } catch (err) {
      console.log("...", err);
    }

  };

  const createBooking = async (successCb, totalTax, grandTotal) =>{

    const priceTiersName = getPriceTierName()
    const priceTiersPrice = getPriceTierPrice()
    const payload = {
        // "purchaser": {  
        //     "firstName": selectedData.defaultQuestions.purchaser.firstName, 
        //     "lastName": selectedData.defaultQuestions.purchaser.lastName, 
        //     "phoneNumber":  selectedData.defaultQuestions.purchaser.phoneNumber, 
        //     "emailAddress":  selectedData.defaultQuestions.purchaser.emailAddress
        // },
        "data": [ 
            {
                "mode": "shared", 
                "resourceGroupId": selectedData.subEvent ? selectedData.subEvent.id : undefined,
                "experienceId": selectedData.type.experienceId,
                "experienceName":selectedData.event.title,
                "category": Object.entries(eventsData).find((entry)=>{
                  const value_ = entry[1];
                  return value_.find(event => event.id == selectedData.event.id)
                })[0],
                "sessionTime":  `${selectedData.date}T${selectedData.timeSlot.startTime}`,  // "2025-09-01T11:00:00", // Session datetime in ISO format (date + time + timezone optional)
                "sessionDuration": eventDetailedInfo && eventDetailedInfo.firstAvailableDate && eventDetailedInfo.firstAvailableDate.sessions && eventDetailedInfo.firstAvailableDate.sessions[0] && eventDetailedInfo.firstAvailableDate.sessions[0].duration ? eventDetailedInfo.firstAvailableDate.sessions[0].duration : ( eventDetailedInfo && eventDetailedInfo.resourceGroups && eventDetailedInfo.resourceGroups[0] && eventDetailedInfo.resourceGroups[0].duration ? eventDetailedInfo.resourceGroups[0].duration : null)  ,
                "totalCost": grandTotal,
                "totalTax": totalTax,
                "participants": [...Array(selectedParticipantCount)].map((_,index)=>{
                  return {
                    "priceTierName": priceTiersName[index], 
                    "firstName": selectedData.defaultQuestions.participants[index].firstName, // Participant’s first name
                    "lastName": selectedData.defaultQuestions.participants[index].lastName, // Participant’s last name
                    "customQuestionResponses": selectedData.participantAnswers[index],
                    "price": priceTiersPrice[index]
                  }
                }),
                "additionalCustomQuestionResponses":selectedData.purchaserAnswers,
                "listingAddOns": selectedData.addOns && selectedData.addOns.length > 0 ? selectedData.addOns.map(addOn => {return {listingAddOnId : addOn.id, quantity: addOn.quantity}}).filter(addOn => addOn.quantity > 0) : [] ,
            }
        ]
    }


    setLoaderDetails({show:true, displayMsg: t("way_activity.loaders.creating_booking")});

    try {
      await createTheWayActivityBooking(payload)
      .then(data=>{
        if(data.bookingId){
          if(successCb) successCb();
          // if(!localStorage.getItem(WAY_ACTIVITIES_USER_DATA)){
          //   localStorage.setItem(WAY_ACTIVITIES_USER_DATA, JSON.stringify({email: selectedData.defaultQuestions.purchaser.emailAddress }))
          // }
        }
        else{
          throw Error();
        }
      })
      .catch((errMessage)=>{
        console.log(errMessage.message)
        props.closeOrderPopUp(true, JSON.stringify(errMessage.message), "", true);
      })
      .finally(()=>{
        setLoaderDetails({show:false });

      })
     
    } catch (err) {
      console.log("...", err);
    }

  }

// FETCH APIS - END

  useEffect(()=>{

    if(selectedParticipantCount){
       handleSelectedDataChange({
       defaultQuestions: getDefaultQuestionsFormat(selectedParticipantCount) 
      })

    }
  }, [selectedParticipantCount])

  useEffect(()=>{ scrollToTop();}, [currentPage])

  useEffect(()=>{console.log(selectedData)},[selectedData]);

  useEffect(() => {
    const isGuestLoggedIn = Boolean(localStorage.getItem('room') && localStorage.getItem('room') != 'null');
    console.log(isGuestLoggedIn, "isGuestLoggedIn");

    if(!isGuestLoggedIn){
      if (process.env.REACT_APP_INROOMTAB == "true") {
        props.setLoginRequired(true);
      } else {
        props.setRegPage(true);
      }
      return;
    }

  }, []);

  useEffect(()=>{
    if(selectedData.timeSlot){
      const key = selectedData.timeSlot.startTime + selectedData.timeSlot.endTime
      // if(visibleTimeSlots[key].length == 1){
      //   handleSelectedDataChange({type: visibleTimeSlots[key][0] });
      // }else{
      //   setVisibleTypes(visibleTimeSlots[key]);
      // }

      const priceTiers = visibleTimeSlots[key][0].priceTiers
      console.log(priceTiers,"priceTiers");
      const updateTiers = priceTiers.map((tier)=>{
        return {...tier, quantity: 0};
      })
      handleSelectedDataChange({priceTiers:updateTiers , type: visibleTimeSlots[key][0]});
      
    }
  },[selectedData.timeSlot])

  useEffect(()=>{

    let updatedSelectedData = {...selectedData};
    delete updatedSelectedData.timeSlot;
    delete updatedSelectedData.priceTiers;
    delete updatedSelectedData.type;
    setVisibleTimeSlots({})
    setSelectedData(updatedSelectedData);
    setSelectedParticipantCount(null);

    
    if(selectedData.date && availabilityApiResponse){
      const dateSpecificSession = availabilityApiResponse.sessions.find(datedSession=>{
        return datedSession.date == selectedData.date;
      })
      
      const sessions = dateSpecificSession.sessions;
      const visibleTimeSlots_ = {...visibleTimeSlots};

      for(const session of sessions){
        const key = session.startTime + session.endTime;
        if(visibleTimeSlots_.hasOwnProperty(key)){
          const currentEntry = visibleTimeSlots_[key];
          const updatedEntry = [...currentEntry, session];
          visibleTimeSlots_[key] = updatedEntry;
        }else {
          visibleTimeSlots_[key]= [session];
        }
      }

      setVisibleTimeSlots(visibleTimeSlots_);

    }
  },[selectedData.date])

  useEffect(()=>{

    if(selectedParticipantCount){

      function findAddOnMaxQuantity(limit){
        if(limit.type == "PER_BOOKING") return limit.value;
        if(limit.type == "PER_PARTICIPANT") return limit.value * selectedParticipantCount;
      }
  
      let addOnsInitialTemplate = []
      if(eventDetailedInfo.addOns && eventDetailedInfo.addOns.length >0 ){
        
        addOnsInitialTemplate = eventDetailedInfo.addOns.map((addOn)=>{
          return {
            ...addOn,
            maxQuantity: addOn && addOn.limit && addOn.limit.value ? findAddOnMaxQuantity(addOn.limit) : 1000000,
            quantity: 0
          }
        })
  
      }
      handleSelectedDataChange({addOns: addOnsInitialTemplate})
    }
    
  },[selectedParticipantCount])



  return (
    <div style={{ color: 'black' }} className="activities">
      {/* <header className="inner-pages w-footer subpages">
        <a className="button-back" onClick={() => goPreviousPage()}></a>
        <div className="heading align-center">
          <div class="header">
            <p className="text">Experiences</p>
            <img src={`${CMSPath}${props.logo}`} alt="" />
          </div>
        </div>
      </header> */}
        {
           <>
          {
            currentPage == 1 && <WayActivity1  
              goNextPage={goNextPage}
              goPreviousPage={goPreviousPage}
              myBookings={myBookings}
              fetchBookings={fetchBookings}
              setLoaderDetails={setLoaderDetails}
            />
          }
          {
            currentPage == 2 && eventsData && <WayActivity2 
              goNextPage={goNextPage}
              goPreviousPage={goPreviousPage}
              eventsData={eventsData}
              selectedData={selectedData}
              handleSelectedDataChange={handleSelectedDataChange}
            />
          }
          {
            currentPage == 3 && selectedData.event && eventDetailedInfo && <WayActivity3
              goNextPage={goNextPage}
              goPreviousPage={goPreviousPage}
              eventDetailedInfo={eventDetailedInfo}
              selectedData={selectedData}
              handleSelectedDataChange={handleSelectedDataChange}
            />
          }
        </>
      }

      {
        ( selectedData.event ) && <>
          {
            currentPage == 4 &&
            <WayActivity4
              goNextPage={goNextPage}
              goPreviousPage={goPreviousPage}
              selectedParticipantCount={selectedParticipantCount}
              setSelectedParticipantCount={setSelectedParticipantCount}
              availabilityApiResponse={availabilityApiResponse}
              handleSelectedDataChange={handleSelectedDataChange}
              selectedData={selectedData}
              visibleTimeSlots={visibleTimeSlots}
              currency = {eventDetailedInfo.currency}
            />
          }
        </>
      }

      {
        selectedData && <>
          {
            currentPage == 5 &&
            <WayActivity5
              goNextPage={goNextPage}
              goPreviousPage={goPreviousPage}
              selectedParticipantCount={selectedParticipantCount}
              handleSelectedDataChange={handleSelectedDataChange}
              selectedData={selectedData}
              eventDetailedInfo = {eventDetailedInfo}
              getPriceTierName={getPriceTierName}
              currency = {eventDetailedInfo.currency}

            />
          }
        </>
      }
      {
        (eventsData) && <>
          {
            currentPage == 6 &&
            <WayActivity6
              goNextPage={goNextPage}
              goPreviousPage={goPreviousPage}
              selectedData={selectedData}
              currency={eventDetailedInfo.currency}
              eventDetailedInfo = {eventDetailedInfo}
            />
          }
        </>
      }
 
      {
        currentPage == 7 &&
        <BookingConfirmation
          goNextPage={goNextPage}
        />
      }

      {
        loaderDetails.show && 
        <Loader displayMsg={loaderDetails.displayMsg}/>  
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
  };
};

export default connect(mapStateToProps,
  { setGoHome, setLoginRequired , setRegPage , setSuccessFailPop, popupOpenClose , closeOrderPopUp})(
    withTranslation("translations")(WayActivities)
  );
